<div class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1 class="m-0 text-dark">Nodal Officer Dashboard</h1>
            </div>
            <div class="col-sm-6">
                <h2 style="float:right">State Name: {{stateName}}</h2>
            </div>
            <!-- /.col -->
        
            <!-- /.col -->
        </div>
        <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
</div>
<!-- /.content-header -->

<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <!-- Small boxes (Stat box) -->
        <div class="row">
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box " style="background-color:#9d86c3;color:black;">
                    <div class="inner">
                        <h3>{{userRecordCount}}</h3>

                        <p>Food Safety On Wheels Registered</p>
                    </div>
                    <div class="icon">
                        <i class="ion ion-bag"></i>
                    </div>
                    <a [routerLink]="['/list-vehicle',stateCode]" class="small-box-footer"
                        >More info <i class="fas fa-arrow-circle-right"></i
                    ></a>
                </div>
            </div>
            <!-- ./col -->
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box " style="background-color:#86c7f3;color:black;">
                    <div class="inner">
                        <h3>{{trainingRecordCount}}</h3>

                        <p>Trainings Conducted</p>
                    </div>
                    <div class="icon">
                        <i class="ion ion-stats-bars"></i>
                    </div>
                    <a [routerLink]="['/list-training',stateCode]" class="small-box-footer"
                        >More info <i class="fas fa-arrow-circle-right"></i
                    ></a>
                </div>
            </div>
            <!-- ./col -->
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box" style="background-color:#ffa1b5;color:black;">
                    <div class="inner">
                        <h3>{{testingRecordCount}}</h3>

                        <p>Sample Tested</p>
                    </div>
                    <div class="icon">
                        <i class="ion ion-person-add"></i>
                    </div>
                    <a [routerLink]="['/list-testing',stateCode]" class="small-box-footer"
                        >More info <i class="fas fa-arrow-circle-right"></i
                    ></a>
                </div>
            </div>
            <!-- ./col -->
            <div class="col-lg-3 col-6">
                <!-- small box -->
                <div class="small-box" style="background-color:#ffe29a;color:black;">
                    <div class="inner">
                        <h3>{{awpRecordCount}}</h3>

                        <p>Awareness Programs Conducted</p>
                    </div>
                    <div class="icon">
                        <i class="ion ion-pie-graph"></i>
                    </div>
                    <a [routerLink]="['/list-awp',stateCode]" class="small-box-footer"
                        >More info <i class="fas fa-arrow-circle-right"></i
                    ></a>
                </div>
            </div>
            <!-- ./col -->
        </div>
        <!-- /.row -->
        <div class="row">
            <div class=" col-md-3">
             </div>
             <div class="col-md-3">
             </div>
             <div class="col-md-3">
             </div>
             <div class="col-md-3">
                 <div class="form-group">
                     <label>
                     Show Chart:
                     <select [(ngModel)]="chartViewType" class="form-control"  (change)="changeView()">
                        
                         <option Value="Vehicle">Vehicles</option>
                         <option Value="Trainings">Trainings</option>
                         <option Value="Testing">Testings</option>
                         <option Value="Awareness Programs">Awareness Programs</option>
                         
                     </select>
                 </label>
                 </div>
             </div>
         </div>
        <div class="row">
            <div class="col-lg-6 col-6">
                <!-- Donut chart -->
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title">
                            <i class="far fa-chart-bar"></i>
                            All Activities
                        </h3>

                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-minus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div style="display: block; height:350px">
                            <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels"
                                [chartType]="doughnutChartType"  [colors]="donutColors"></canvas>
                        </div>
                    </div>
                    <!-- /.card-body-->
                </div>
                <!-- /.card -->

            </div>
            <div class="col-lg-6 col-6">
         
                <div class="card card-primary card-outline">
                    <div class="card-header">
                        <h3 class="card-title">
                            <i class="far fa-chart-bar"></i>
                           
                            {{barChartTitle}}
                        </h3>

                        <div class="card-tools">
                            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                <i class="fas fa-plus"></i>
                            </button>
                            <button type="button" class="btn btn-tool" data-card-widget="remove">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div style="display: block; height:300px">
                            <canvas baseChart  
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [colors]="barChartColors"
            [options]="barChartOptions"
            [legend]="barChartLegend"
            [chartType]="barChartType">
             </canvas>
                        </div>
                        <br>
                        <br>
                    </div>
                    
                </div>
                

            </div>
            
        </div>
    </div>
    <!-- Main row -->
</section>
<!-- /.content -->
